import { render, staticRenderFns } from "./VipSet.vue?vue&type=template&id=506a7ec3"
import script from "./VipSet.vue?vue&type=script&lang=js"
export * from "./VipSet.vue?vue&type=script&lang=js"
import style0 from "./VipSet.vue?vue&type=style&index=0&id=506a7ec3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports